module.exports = __webpack_public_path__ + "Icono_CotizarProducto_512px.png";